import { RiPhoneFill, RiExternalLinkFill, RiArrowLeftCircleFill, RiMailOpenFill } from "react-icons/ri";
import { useParams } from "react-router-dom";
import NavCard from "../../Partials/Layouts/NavCardList/NavCard/NavCard";
import NavCardList from "../../Partials/Layouts/NavCardList/NavCardList";

function OrganizationContacts() {

    const {organizationID} = useParams()
    return (
        <NavCardList numOfCards={'four_nav_cards_list'}>
            <NavCard cardName='Organization Phone Numbers' navCardLink={'/organizationPhones/' + organizationID}>
                <RiPhoneFill />
            </NavCard>
            <NavCard cardName='Organization Links' navCardLink={'/organizationLinks/' + organizationID}>
                <RiExternalLinkFill />
            </NavCard>
            <NavCard cardName='Organization Emails' navCardLink={'/organizationEmails/' + organizationID}>
                <RiMailOpenFill />
            </NavCard>
            <NavCard cardName='Go Back' navCardLink={'/organizations/'}>
                <RiArrowLeftCircleFill />
            </NavCard>
        </NavCardList>
    )
}

export default OrganizationContacts